import { includes } from 'lodash/fp';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from '@sentry/browser';

import { sendEventLog } from '../log/services';

const sagaMiddleware = createSagaMiddleware({
  onError: (error) => {
    Sentry.captureException(error);
  },
});

const eventLogger = (store) => (next) => (action) => {
  const state = store.getState();
  const eventData = {
    category: 'school',
    label: action.type,
    action: 'click',
  };

  if (!includes('REQUEST', action.type)) {
    sendEventLog(eventData, state.user.info);
  }

  return next(action);
};

export default [sagaMiddleware, eventLogger];
